"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./MVPbenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/wpad.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "UNDERSTAND USERS NEEDS",
      description: "Explore how your user interacts with your MVP product and how it compares with competitors.",
    },
    {
      iconSrc: "/calci.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Plan Costs Icon",
      title: "REDUCE DEVELOPMENT RISK",
      description: "Prototyping a software MVP will help you properly define the necessary development requirements and make on time.",
    },
    {
      iconSrc: "/plan.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "MARKET VALIDATION",
      description: "An MVP allows you to test assumptions with users and validate your business model based on this user-experience.",
    },
    {
      iconSrc: "/target.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "FOCUS ON CORE FUNCTIONALITY",
      description:
        "Through early adopters and users, understand the features that users value the most and the ones that are missing.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title1 animate-left" ref={headerRef}>
            Prototype your
product
            <br />
            TO VALIDATE YOUR
            <br />
            <span className="scoping-benefits-highlight"> BUSINESS IDEA</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
            In our Minimum Viable Product (MVP) development approach, our team of experts will collaborate with you to research your business idea, identify the core functionalities and build an MVP prototype to validate your assumptions.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
